import { toast } from 'react-toastify'
import { StakeholderType, UserType } from '../types/user'

/**
 * Handle profile permission errors (403 Forbidden)
 */
export const handleProfilePermissionError = (
  error: unknown,
  requiredProfile?: StakeholderType,
) => {
  if (
    error &&
    typeof error === 'object' &&
    'response' in error &&
    error.response &&
    typeof error.response === 'object' &&
    'status' in error.response &&
    error.response.status === 403
  ) {
    const message = requiredProfile
      ? `Switch to ${getProfileDisplayName(requiredProfile)} profile to access this feature`
      : "You don't have permission to access this feature with your current profile"

    toast.error(message, {
      autoClose: 5000,
    })
    return true
  }
  return false
}

/**
 * Get user-friendly display name for stakeholder type (company roles)
 */
export const getProfileDisplayName = (
  stakeholderType: StakeholderType,
): string => {
  switch (stakeholderType) {
    case StakeholderType.CONTRACTOR:
      return 'Contractor'
    case StakeholderType.BROKER:
      return 'Broker'
    case StakeholderType.SUB_HAULER:
      return 'Sub-Hauler'
    default:
      return stakeholderType
  }
}

/**
 * Get user-friendly display name for user type (individual positions)
 */
export const getUserTypeDisplayName = (userType: UserType): string => {
  switch (userType) {
    case UserType.DRIVER:
      return 'Driver'
    case UserType.DISPATCHER:
      return 'Dispatcher'
    case UserType.PROJECT_MANAGER:
      return 'Project Manager'
    case UserType.SITE_SUPERVISOR:
      return 'Site Supervisor'
    case UserType.ADMINISTRATOR:
    case UserType.OWNER:
      return 'Administrator'
    default:
      return userType
  }
}

/**
 * Check if user has required profile active
 */
export const hasRequiredProfile = (
  currentProfile?: { stakeholder_type: string },
  requiredProfile?: StakeholderType,
): boolean => {
  if (!currentProfile || !requiredProfile) return false
  return currentProfile.stakeholder_type === requiredProfile
}
